import { Fragment, FunctionComponent, Suspense } from 'react';
import { Container, MuiThemeProvider } from '@material-ui/core';
import { OnsaHeader, theme } from '@flos/react-components';
import RouterApp from './../router/RouterApp';
import { IAppProps } from '../common/interface/IAppProvider';
import { useGlobalState } from '../common/context/AppContext';
import { ProgressBar } from '../components/shared/progress-bar/progress-bar';
import { getContentBlock, getResourceBundle } from '../common/actions/GetResourceBundle';
import './App.css';

export const resourceBundlesList = [
    'onsa.travel.household',
    'onsa.travel.receipt',
    'onsa.travel.intro',
    'onsa.travel.basket',
    'onsa.travel.aboutyou',
    'onsa.travel.termination',
    'onsa.travel.call.me',
    'onsa.travel.404',
    'onsa.travel.packages',
    'onsa.travel.payment.options',
    'onsa.travel.payment.frequency',
    'onsa.travel.compliance',
    'onsa.travel.receipt',
    'onsa.travel.progressbar',
    'onsa.travel.error',
    'dk.onsa-common'
];

export const contentBlockList = [
    'onsa.travel.intro',
    'onsa.travel.intro-wo-content-1',
    'onsa.travel.intro-wo-content-2',
    'onsa.travel.call.me.no.content',
    'onsa.travel.call.me.no.option',
    'onsa.travel.call.me.no.online',
    'onsa.travel.call.me.no.login',
    'onsa.travel.call.me.student',
    'onsa.travel.call.me',
    'onsa.travel.call.me.receipt',
    'onsa.travel.login',
    'onsa.travel.packages.2023',
    'onsa.travel.coverage.skisport',
    'onsa.travel.coverage.afbestilling',
    'onsa.travel.payment.options',
    'onsa.travel.payment.options.1',
    'onsa.travel.payment.frequency',
    'onsa.travel.basket',
    'onsa.travel.basket.docover',
    'onsa.travel.basket.fees',
    'onsa.travel.basket.fees.header',
    'onsa.travel.aboutyou',
    'onsa.travel.termination',
    'onsa.travel.termination.datepicker',
    'onsa.travel.termination.when',
    'onsa.travel.termination.quick',
    'onsa.travel.termination.companies',
    'onsa.travel.compliance',
    'onsa.travel.receipt',
    'onsa.travel.receipt.footer',
    'onsa.travel.error.existing.travel',
    'onsa-daekker-resten-af-verden',
    'onsa-afbestilling',
    'onsa-daekker-i-europa',
    'onsa-sygdom-og-tilskadekomst',
    'onsa-forsinkelse-pa-rejsen',
    'onsa-forsinket-bagage',
    'onsa-odelagte-feriedogn',
    'onsa-selvrisiko-ved-lejebil',
    'customer-rejection',
    'customer-rejection-bornholm',
    'common/insurance-exists',
    'domestic-address-rejection'
];

const appTheme = {
    ...theme,
    overrides: {
        ...theme.overrides,
        MuiPaper: {
            ...theme.overrides?.MuiPaper,
            root: { ...theme.overrides?.MuiPaper?.root, maxWidth: '490px !important' }
        }
    }
};

export const App: FunctionComponent<IAppProps> = (props): JSX.Element => {
    const { actualStep, refreshFromCache } = useGlobalState();

    // start loading all the content blocks
    for (const element of contentBlockList) {
        if (!(element in props.config.contentBlocks)) {
            props.config.contentBlocks[element] = getContentBlock(element, props.config.contentBlockApiUrl);
        }
    }

    // start loading all the resource bundles
    for (const element of resourceBundlesList) {
        if (!(element in props.config.resourceBundles)) {
            props.config.resourceBundles[element] = getResourceBundle(element, props.config.resourceBundleApiUrl);
        }
    }

    return (
        <div className="onsa-main-wrapper">
            <OnsaHeader />
            <div className="onsa-travel-area">
                {((actualStep < 3 || actualStep > 8) && props.pageType === 'app') || props.pageType === 'receipt' ? (
                    ''
                ) : (
                    <div className="progress-bar-wrapper">
                        <div role="progressbar" className="progress-bar-inner-wrapper">
                            <Suspense fallback={<Fragment />}>
                                <ProgressBar {...props} />
                            </Suspense>
                        </div>
                    </div>
                )}
                <Container fixed>
                    <MuiThemeProvider theme={appTheme}>
                        <div className="onsa-main-inner-wrapper">{refreshFromCache && <RouterApp {...props} />}</div>
                    </MuiThemeProvider>
                </Container>
            </div>
        </div>
    );
};

export default App;
